import axios from "axios";
import { templateProviderDiagnostics } from "./utils/template-provider-diagnostics";
import { getRestApiUrl } from "./utils/backendOverride";
import { endUnauthorizedSession } from "./utils/unauthorizedSession";
import { canEndNormalSession } from "./utils/partnerAccess/sedeSession";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API}`,
});

API.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${process.env.REACT_APP_TOKEN_PAYMENTS}`;
  // Resolved per request: the A/B company is routed to the sin-Prisma backend.
  config.baseURL = `${getRestApiUrl()}/v2`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    // `message` conserva la semántica legacy (userMessage o el data completo);
    // el resto son campos aditivos para que los consumidores puedan mapear
    // códigos de error sin depender de ese shape.
    const jcnError = {
      message: data?.userMessage || data,
      errorCode: data?.error,
      userMessage: data?.userMessage,
      internalCode: data?.internalCode,
      httpCode: error.response?.status,
      // Preserve legacy ownership when absent, but never promote malformed refs.
      ...(data?.supportRef === undefined ? { supportRef: undefined } : {}),
      ...templateProviderDiagnostics(data),
    };
    // Partner access: this client never carries the delegated token, so in
    // sede mode its failure says nothing about the sede and must not end the
    // normal session.
    if (jcnError.message === "UNAUTHORIZED" && canEndNormalSession()) {
      endUnauthorizedSession();
    }
    return Promise.reject(jcnError);
  }
);

export default API;
